export const EMAIL_SIGNUP_LABELS = {
  checkout: {
    shipping: {
      lbl_shipping_emailSignUpHeader_ca_new: 'Sign Up For Emails',
      lbl_shipping_emailSignUpHeader: 'SIGN UP FOR EMAILS*',
      lbl_shipping_emailSignUpSubHeader: 'Stay updated on special promos & new arrivals.',
    },
  },
};

export const CONTACT_FORM_LABELS = {
  checkout: {
    pickup: {
      lbl_pickup_govIdText: 'A government issued ID is required to pickup the order.',
      lbl_pickup_mobile: 'Mobile Number',
    },
  },
};

export const CHECKOUT_PROGRESS_INDICATOR_LABELS = {
  checkout: {
    checkoutHeader: {
      lbl_checkoutHeader_billing: 'Billing',
      lbl_checkoutHeader_review: 'Review',
    },
  },
};

export const EMPTY_CHECKOUT_BAG_LABELS = {
  checkout: {
    review: {
      lbl_review_emptyBagText: 'YOUR SHOPPING BAG IS EMPTY',
      lbl_review_emptyBagSubText:
        "Your shopping bag is empty. Shopping bags are saved for 14 days for account holders. Try logging in to your account to view a saved shopping bag. If you don't see your items you may have not made your selections correctly on the product page.",
    },
  },
};

export const CHECKOUT_FOOTER_LABELS = {
  checkout: {
    review: {
      lbl_review_afterpayThresholdError:
        'Afterpay is available for orders that total between $[AfterPayMinOrderAmount] - $[AfterPayMaxOrderAmount]. Please select a new payment method.',
    },
  },
};

export const CHECKOUT_ORAGANISMS_LABELS = 'checkout';
export const CHECKOUT_BILLING_LABELS = 'checkout.billing';
export const GLOBAL_ADD_EDIT_ADDRESS_LABELS = 'global.addEditAddress';

export const GLOBAL_CC_LABELS = 'global.creditCardFields';

export const CheckoutOrganismsLabels = {
  checkout: {
    billing: {
      lbl_billing_saveToAccount: 'Save card to my account',
      lbl_billing_defaultPayment: 'Set as default payment method',
      lbl_edit_card_info: 'Edit Card Information',
      lbl_update_card_info: 'Update Card Information',
      lbl_add_new_card_info: 'Add New Card Information',
      lbl_my_wallet: 'My Wallet',
      lbl_add_card: 'Add Card',
      lbl_expired: 'Expired',
      lbl_billing_default: 'Default',
      lbl_billing_creditCardEnd: 'ending in ',
      lbl_billing_cvvCode: 'CVV',
      lbl_add_new_card: 'Add New Card',
      lbl_billing_addCC: 'Add a new CC',
      lbl_billing_billingAddress: 'Billing Address',
      lbl_billing_cardDetailsTitle: 'Card Details',
      lbl_orderTotal_threshold_msg:
        'Afterpay is available for orders that total between $[AfterPayMinOrderAmount] - $[AfterPayMaxOrderAmount]. Please select a new payment method.',
      lbl_billing_afterpaySubmit: 'CONTINUE WITH AFTERPAY',
      lbl_afterPay_default_msg:
        'You will be directed to Afterpay once you submit your order on the next step.',
      lbl_afterPay_gc_in_cart_msg:
        'Afterpay is unavailable for gift card purchases. Please select a new payment method.',
      lbl_billing_paymentMethodTitle: 'Payment Method',
      lbl_billing_continueWith: 'Continue with',
      lbl_billing_cardEditSave: 'Save',
      lbl_billing_sameAsShipping: 'Same as shipping address',
      lbl_billing_default_card: 'DEFAULT',
      lbl_billing_addNewAddress: '+ Add a new addres',
      lbl_billing_sameAsShippingMessage: 'My billing address is the same as shipping.',
      lbl_addEditAddress_regEditAddress: 'Edit Address',
      lbl_gift_card_applied: 'Gift Cards Applied',
      lbl_gift_card_available: 'Gift Cards Available',
      lbl_apply_a_gift_card: 'Apply a Gift Card',
      lbl_giftcard_headsUpTitle: 'Heads Up!',
      lbl_giftcard_headsUpMsg:
        'Please keep your Gift Card until you receive the item(s) purchased.',
      lbl_creditCard_fields: 'Credit Card Fields',
      lbl_giftcard_addUptoMsg: 'Add up to #maxGiftCard# gift cards and/or merchandise credits.',
    },
    shipping: {
      lbl_giftServices_help: 'Gift Services Help',
    },
  },
  global: {
    creditCardFields: {
      lbl_creditField_cardNumber: 'Credit Card Number',
      lbl_creditField_expMonth: 'Exp. Month',
      lbl_creditField_expYear: 'Exp. Year',
      lbl_creditField_cvvCode: 'CVV',
      lbl_creditField_cameraText: 'Position your card in the frame',
      lbl_creditField_cardNumberHash: 'Credit Card #',
    },
    addEditAddress: {
      lbl_addEditAddress_selectFromAddress: 'Address book',
      lbl_addEditAddress_addAddress: 'Add Address',
      lbl_addEditAddress_regAddNewAddress: 'Add New Address',
    },
  },
  account: {
    common: {
      lbl_common_makeDefault: 'Make Default',
    },
  },
};
